module.exports = __webpack_public_path__ + "media/images/home-4-2489bc091ffda78c67bfe58e6d0b87bd.svg";